// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__uUpbS","tab":"Tabs_tab__2sef2","tabActive":"Tabs_tabActive__SKMfU"};